import { FIRST_TIME_LOGIN_URL, OTP_SENT, VIEW_USER_PROFILE, get_headers } from '@/utils/system_constants/constant.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { password_visibility_mixin } from '@/utils/mixins/password_visibility_mixin.js';
import { validate_non_empty_string, validate_phone_number  } from '@/utils/mixins/validate_inputs.js'
import axios from 'axios';
import $ from 'jquery';
import OnboardingIndex from '../OnboardingIndex.vue';

export default {
  name: 'FirstTimeLogin',
  mixins: [alert_mixin ,password_visibility_mixin ],
  components: {
    OnboardingIndex
    
  },
  data: () => ({
    show_password: false, // Toggle for password visibility
    show_confirm_password: false,
    user_first_name: null,
    user_last_name: null,
    user_email: '',
    organization_name: '',
    show_name_inputs: false,
    new_password: '',
    confirm_password: '',
    phone_number:'',
    action_running: false,
    user_id: sessionStorage.getItem('user_id') || null,

    token: null,
    headers: null,
    eye_icon: 'bi-eye-slash',
  }),

  mounted() {
    this.initializeAuth();
    this.initializeUserId();
    this.initializeOrganizationContext();
    this.initializeAdminContext();
    this.document_ready();
  },
  methods: {
    initializeAuth() {
      this.token = sessionStorage.getItem("token");
      this.headers = get_headers();
    },

    initializeUserId() {
      this.user_id =
        sessionStorage.getItem("user_id") ||
        this.$route.query.user_id ||
          null;

      if (this.user_id) {
        sessionStorage.setItem("user_id", this.user_id);
      }
    },

    initializeNameInputs() {
      this.show_name_inputs =
        this.user_first_name == null || this.user_last_name == null;
    },
    initializeOrganizationContext() {
      const raw_organization = sessionStorage.getItem('current_organization');
      if (!raw_organization) {
        return;
      }

      try {
        const organization = JSON.parse(raw_organization);
        this.organization_name = organization?.name || '';
      } catch {
        this.organization_name = '';
      }
    },
    initializeAdminContext() {
      this.user_first_name = sessionStorage.getItem('admin_first_name') || null;
      this.user_last_name = sessionStorage.getItem('admin_last_name') || null;
      this.user_email = sessionStorage.getItem('admin_email') || '';
      this.initializeNameInputs();
    },
    async handle_success_password_change(user_id) {
      const data = { user_id };
      try {
        await axios.post(OTP_SENT, data, {
          headers: this.headers
        });
        return;
      } catch {
        this.show_error('Could not send OTP to user.');
      }
    },
    async get_user_details() {
      const data = {
        user_id: this.user_id
      };
      
      try {
        const response = await axios.post(VIEW_USER_PROFILE, data, {
          headers: this.headers
        });
        const response_data = JSON.parse(response.data);
        this.user_first_name = response_data.data[0].user.first_name ? response_data.data[0].user.first_name : null;
        this.user_last_name = response_data.data[0].user.last_name ? response_data.data[0].user.last_name : null;
      } catch {
        this.show_error('Could not get user profile.');
      }
    },
    build_login_payload() {
      const login_payload = {
        first_name: this.user_first_name,
        last_name: this.user_last_name,
        new_password: this.new_password,
        confirm_password: this.confirm_password,
        phone_number: this.phone_number,
        user_id: this.user_id
  };
  return login_payload;
},
validate_login_fields() {
  validate_non_empty_string(this.user_first_name, 'Your First name is required');
  validate_non_empty_string(this.user_last_name, 'Your Last name is required');
  validate_non_empty_string(this.new_password, 'A Password is required');
  validate_non_empty_string(this.confirm_password, 'Please confirm your password');
},

async process_login_success(response_data) {
  this.show_success(response_data.message);
  this.action_running = false;

  if (response_data.user_id) {
    this.user_id = response_data.user_id;
    sessionStorage.setItem('user_id', this.user_id);
  }

  sessionStorage.setItem(
    'profile_role_form_id',
    response_data.profile_role_form_id
  );

  await this.handle_success_password_change(this.user_id);

  this.$router.push({
    path: '/one_time_pin',
    query: {
      user_id: this.user_id
    }
  });
},
first_time_login() {
  if (!this.validate_inputs()) {
    return;
  }

  axios.post(
    FIRST_TIME_LOGIN_URL,
    this.build_login_payload(),
    {
      headers: this.headers
    }
  )
  .then((response) => {
    const response_data = JSON.parse(response.data);

    if (response_data.status !== 'success') {
      this.action_running = false;
      this.show_error('Error during the form submission.');
      return;
    }

    return this.process_login_success(response_data);
  })
  .catch((error) => {
    this.action_running = false;
    this.handle_axios_error(error);
  });
},
handle_axios_error(error) {
  let data = error?.response?.data;

  if (typeof data === "string") {
    data = JSON.parse(data);
  }

  return this.show_error(
    data?.message ||
    data?.detail ||
    error?.message ||
    "An unexpected error occurred."
  );
},
  
    validate_inputs() {

      if (!this.new_password) {
          this.show_info('Password is required');
          this.action_running = false;
          return false;
      }

      if (!this.confirm_password) {
          this.show_info('Confirm password is required');
          this.action_running = false;
          return false;
      }

      if (this.new_password !== this.confirm_password) {
          this.show_info('Passwords do not match.');
          this.action_running = false;
          return false;
      }

      this.action_running = true;
      return true;
    },
    document_ready() {
     $('#show-password').on('change', () => {
  const password_field = $('.password');
  const password_field_type = password_field.attr('type');

  password_field.attr(
    'type',
    password_field_type === 'password'
      ? 'text'
      : 'password'
  );
});
    },

    validate_phone_number(phone_number) {
      return validate_phone_number(phone_number)
    },
  }
};
